const kitchen = [
  {
    regNum: 62,
    item: "mozuku",
    desc: "mozuku seaweed with sweet vinegar sauce"
  },
  {
    regNum: 63,
    item: "sunomono",
    desc: "sliced cucumber + sliced octopus in sweet vinegar sauce"
  },
  {
    regNum: 65,
    item: "namuru",
    desc: "boiled spinach seasoned with sesame oil and soy sauce"
  },
  {
    regNum: 67,
    item: "edamame",
    desc: "boiled soy beans"
  },
  {
    regNum: 100,
    item: "soboro don - small",
    desc: "ground chicken cooked with soy sauce and mirin over rice"
  },
  {
    regNum: 101,
    item: "soboro don - regular",
    desc: "ground chicken cooked with soy sauce and mirin over rice"
  },
  {
    regNum: 102,
    item: "unagi don",
    desc: "fresh water eel grilled and served over rice"
  },
  {
    regNum: 104,
    item: "ochazuke",
    desc: "rice in hot soup with seaweed and your choice of topping - plum, salmon, tarako"
  },
  {
    regNum: 105,
    item: "onigiri",
    desc: "triangular shaped rice ball with your choice of stuffing - plum, salmon, tarako, dried bonito"
  },
  {
    regNum: 106,
    item: "yaki onigiri",
    desc: "char-broiled triangular rice ball with your choice of stuffing - plum, salmon, tarako, dried bonito or house special (bonito, scallions, sesame oil, sesame seeds)"
  },
  {
    regNum: 107,
    item: "yaki onigiri - plain",
    desc: ""
  },
  {
    regNum: 108,
    item: "tomato salad",
    desc: ""
  },
  {
    regNum: 109,
    item: "salmon skin salad",
    desc: ""
  },
  {
    regNum: 172,
    item: "green salad",
    desc: "",
  },
  {
    regNum: 111,
    item: "mixed pickles",
    desc: ""
  },
  {
    regNum: 112,
    item: "miso soup",
    desc: ""
  },
  {
    regNum: 113,
    item: "rice",
    desc: ""
  },
  {
    regNum: 114,
    item: "ice cream",
    desc: ""
  },
  {
    regNum: 115,
    item: "omochi ice cream",
    desc: ""
  }
]

export default kitchen;